import React, { useState, useEffect } from 'react';
import { ScanLine, RefreshCw } from 'lucide-react';
import { useApi } from './DashboardLayout';

export default function VerificationLogPage() {
  const [logs, setLogs] = useState(null);
  const [loading, setLoading] = useState(true);
  const { apiFetch } = useApi();

  const loadLogs = async () => {
    setLoading(true);
    const r = await apiFetch('/api/surveys/verification-log?limit=200');
    const d = await r?.json();
    if (d) setLogs(d);
    setLoading(false);
  };

  useEffect(() => { loadLogs(); }, []);

  const formatDate = (iso) => {
    if (!iso) return '–';
    const d = new Date(iso);
    return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
      + ' ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div data-testid="verification-log-page">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>QR-Code Verifizierungsprotokoll</h2>
        <button className="btn btn-secondary" style={{ padding: '6px 14px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}
          onClick={loadLogs} disabled={loading} data-testid="verify-log-refresh">
          <RefreshCw size={14} className={loading ? 'spin' : ''} /> Aktualisieren
        </button>
      </div>

      <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>
        Hier sehen Sie alle Zugriffe auf die QR-Code-Verifizierungsseite. Jeder Scan eines QR-Codes auf einem
        Bestandserhebungs-PDF wird protokolliert.
      </p>

      {loading && !logs ? (
        <div style={{ padding: 24, textAlign: 'center', color: 'var(--text-muted)' }}>Lade Protokoll...</div>
      ) : logs?.total === 0 ? (
        <div className="of-card" style={{ padding: 24, textAlign: 'center' }}>
          <ScanLine size={32} style={{ color: 'var(--text-muted)', marginBottom: 8 }} />
          <p style={{ fontSize: 14, color: 'var(--text-muted)' }}>Noch keine QR-Code-Scans registriert.</p>
          <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>Sobald jemand einen QR-Code auf einem Bestandserhebungs-Zertifikat scannt, erscheint der Eintrag hier.</p>
        </div>
      ) : (
        <div className="of-card">
          <div style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', fontSize: 13, color: 'var(--text-muted)' }}>
            {logs?.total} Scan(s) insgesamt
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table className="of-table" style={{ fontSize: 13, width: '100%' }} data-testid="verify-log-table">
              <thead>
                <tr>
                  <th style={{ padding: '10px 14px' }}>Zeitpunkt</th>
                  <th style={{ padding: '10px 14px' }}>Anbieter</th>
                  <th style={{ padding: '10px 14px' }}>Zertifikat-Nr.</th>
                  <th style={{ padding: '10px 14px' }}>Status</th>
                  <th style={{ padding: '10px 14px' }}>IP-Adresse</th>
                  <th style={{ padding: '10px 14px' }}>Browser</th>
                </tr>
              </thead>
              <tbody>
                {logs?.logs?.map((log, i) => (
                  <tr key={i}>
                    <td style={{ padding: '10px 14px', whiteSpace: 'nowrap' }}>{formatDate(log.scanned_at)}</td>
                    <td style={{ padding: '10px 14px' }}>{log.provider_name || '–'}</td>
                    <td style={{ padding: '10px 14px', fontFamily: 'monospace', fontSize: 12 }}>{log.verification_hash || log.hash || '–'}</td>
                    <td style={{ padding: '10px 14px' }}>
                      {log.is_valid
                        ? <span className="badge badge-success">Gültig</span>
                        : <span className="badge badge-neutral">Ungültig</span>
                      }
                    </td>
                    <td style={{ padding: '10px 14px', fontSize: 12, color: 'var(--text-muted)' }}>{log.ip || '–'}</td>
                    <td style={{ padding: '10px 14px', fontSize: 11, color: 'var(--text-muted)', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{log.user_agent || '–'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
